import { memo, useEffect, useMemo } from 'react';

import { Input } from 'antd';

import { CloseSquareTwoTone, setTwoToneColor } from '@ant-design/icons';
import debounce from 'lodash.debounce';

import { SEARCH_DEBOUNCE_DELAY } from '../../constants/common';

import './styles.scss';

const { Search } = Input;

setTwoToneColor('#51ae32');

function AppSearch({ className, defaultValue, id, loading = false, placeholder, handleChange }) {
  if (!handleChange) return;

  const debouncedChange = useMemo(() => debounce(handleChange, SEARCH_DEBOUNCE_DELAY), [handleChange]);

  useEffect(() => {
    return () => {
      debouncedChange.cancel();
    };
  }, [debouncedChange]);

  return (
    <Search
      allowClear={{ clearIcon: <CloseSquareTwoTone style={{ fontSize: 16 }} title="Reset" /> }}
      name="query"
      size="large"
      type="search"
      className={`head-search ${className}`}
      defaultValue={defaultValue}
      enterButton
      id={id}
      loading={loading}
      placeholder={placeholder}
      onChange={e => debouncedChange(e.target.value)}
    />
  );
}

export default memo(AppSearch);
